import { Stats } from '../../types/dashboard';
import { FileCheck, FileText, Wallet, FileSpreadsheet, CheckCircle2 } from 'lucide-react';

interface DashboardStatsProps {
  stats: Stats;
}

export default function DashboardStats({ stats }: DashboardStatsProps) {
  const formatCurrency = (value: number) =>
    new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(value);

  const cards = [
    {
      label: 'Potentiel',
      value: stats.potentialCount,
      icon: FileSpreadsheet,
      iconBg: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
      iconColor: '#fff',
      accent: '#f59e0b',
      accentBg: '#fffbeb',
    },
    {
      label: 'Compromis',
      value: stats.compromisCount,
      icon: FileCheck,
      iconBg: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
      iconColor: '#fff',
      accent: '#3b82f6',
      accentBg: '#eff6ff',
    },
    {
      label: 'Acté',
      value: stats.acteCount,
      icon: FileText,
      iconBg: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
      iconColor: '#fff',
      accent: '#10b981',
      accentBg: '#ecfdf5',
    },
    {
      label: 'Encaissé',
      value: stats.encaisseCount,
      icon: Wallet,
      iconBg: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
      iconColor: '#fff',
      accent: '#06b6d4',
      accentBg: '#ecfeff',
    },
    {
      label: 'Clôturé',
      value: stats.clotureCount,
      icon: CheckCircle2,
      iconBg: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
      iconColor: '#fff',
      accent: '#8b5cf6',
      accentBg: '#f5f3ff',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
      {cards.map((card) => {
        const Icon = card.icon;
        return (
          <div
            key={card.label}
            className="rounded-2xl p-5 transition-all duration-200"
            style={{
              backgroundColor: 'var(--color-surface)',
              border: '1px solid var(--color-border)',
              boxShadow: 'var(--shadow-card)',
            }}
            onMouseEnter={e => { (e.currentTarget as HTMLElement).style.boxShadow = 'var(--shadow-card-hover)'; }}
            onMouseLeave={e => { (e.currentTarget as HTMLElement).style.boxShadow = 'var(--shadow-card)'; }}
          >
              <div className="flex items-start justify-between mb-3">
                <p className="text-xs font-medium leading-tight" style={{ color: 'var(--color-text-secondary)' }}>
                  {card.label}
                </p>
                <div
                  className="h-9 w-9 rounded-xl flex items-center justify-center flex-shrink-0"
                  style={{ background: card.iconBg }}
                >
                  <Icon size={16} color={card.iconColor} />
                </div>
              </div>

              <p
                className="text-2xl font-bold leading-none"
                style={{ color: 'var(--color-text-primary)' }}
              >
                {card.value}
              </p>

              {/* Barre de couleur décorative en bas */}
              <div
                className="mt-3 h-0.5 rounded-full"
                style={{ backgroundColor: card.accentBg }}
              >
                <div
                  className="h-full w-2/3 rounded-full"
                  style={{ backgroundColor: card.accent, opacity: 0.5 }}
                />
              </div>
            </div>
          );
        })}
    </div>
  );
}
